// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2M7x4","content":"Consent_content__102d2","footer":"Consent_footer__2Yl5f"};